import { render, staticRenderFns } from "./razon.vue?vue&type=template&id=dcefa0a4&"
import script from "./razon.vue?vue&type=script&lang=js&"
export * from "./razon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports